import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";

const colorCss = config.css.color;
const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const MARGIN_BETWEEN_BTNS = 3;

const css = {
  root: {
    display: "flex",
    alignItems: "stretch",
    marginBottom: MARGIN_BETWEEN_BTNS
  }
};

const CustomListItem = withStyles({
  root: {
    paddingTop: 11,
    paddingBottom: 11
  },
  dense: {
    paddingTop: 8,
    paddingBottom: 8
  }
})(ListItem);
const CustomListItemIcon = withStyles({
  root: {
    display: "flex",
    alignItems: "center",
    marginLeft: -4,
    width: 22,
    height: 22
  }
})(ListItemIcon);
const CustomListItemText = withStyles(
  getDeviceType() === "mobile"
    ? {
        root: { margin: 0 },
        primary: {
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          fontSize: mobileCss.fontSizeOfTextBtn
        },
        secondary: { fontSize: mobileCss.fontSizeOfTextBtn - 2, paddingTop: 2 }
      }
    : {
        root: { display: "flex", alignItems: "center", margin: 0 },
        primary: {
          display: "flex",
          alignItems: "center",
          paddingRight: 16,
          flexShrink: 0,
          fontSize: desktopCss.fontSizeOfTextBtn
        },
        secondary: { fontSize: desktopCss.fontSizeOfTextBtn - 2 }
      }
)(ListItemText);

class CommonListItemButtonView extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    dense: PropTypes.bool,
    color: PropTypes.oneOf(["normal", "highlighted"]),
    primary: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      .isRequired,
    secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    icon: PropTypes.object
  };

  static defaultProps = {
    dense: false,
    color: "normal",
    secondary: null,
    icon: null
  };

  getColor() {
    const { color } = this.props;
    switch (color) {
      case "normal":
        return colorCss.backgroundColorOfNormalListButton;
      case "highlighted":
        return colorCss.backgroundColorOfHighlightedListButton;
      default:
        return null;
    }
  }

  render() {
    const { onClick, dense, primary, secondary, icon } = this.props;

    return (
      <div style={css.root}>
        <CustomListItem
          style={{ backgroundColor: this.getColor() }}
          dense={dense}
          button
          onClick={onClick}
        >
          {icon && <CustomListItemIcon>{icon}</CustomListItemIcon>}
          <CustomListItemText
            primary={primary}
            secondary={secondary}
          ></CustomListItemText>
        </CustomListItem>
      </div>
    );
  }
}

export default CommonListItemButtonView;
